import * as React from 'react';
import { Header3, Paragraph2 } from '@cian/ui-kit';
import classNames from 'classnames';

import * as styles from './promoIntro.css';

export interface IPromoItemProps {
  dueDate?: string;
  name: string;
  onClick(): void;
  onHover(): void;
  icon?: string | null;
  subtitle?: string;
  isFromBank?: boolean;
}

export const PromoIntro = ({ name, dueDate, onClick, onHover, subtitle, icon, isFromBank }: IPromoItemProps) => {
  return (
    <div className={styles['promo']} onClick={onClick} onMouseEnter={onHover}>
      {icon && (
        <div className={classNames(styles['icon'], { [styles['icon-stroke']]: !isFromBank })}>
          <img width="56" height="56" src={icon} />
        </div>
      )}
      <div className={styles['description']}>
        <Header3 color="current_color">{name}</Header3>
        {(subtitle || dueDate) && (
          <Paragraph2 color="gray60_100">
            {subtitle && <p className={styles['subtitle']}>{subtitle}</p>}
            {dueDate && <p className={styles['subtitle']}>{dueDate}</p>}
          </Paragraph2>
        )}
      </div>
    </div>
  );
};
